import { Fieldset, Stack, Title, Text } from '@mantine/core';
import { FacesSetting } from './settings/FacesSetting';
import { TexturesSetting } from './settings/TexturesSetting';
import { MegabytesSetting } from './settings/MegabytesSetting';

export function LimitsOperation() {
  return (
    <Stack>
      <Title order={5}>Limits</Title>
      <Text c='gray.6'>
        Choose one or more limiting factors for your optimization. Limits are designed as maximum allowed factors. This
        can result in less faces or file size than requested due to another limit.
      </Text>
      <Stack gap='lg'>
        <FacesSetting />
        <TexturesSetting />
        <MegabytesSetting />
      </Stack>
    </Stack>
  );
}
